import _ from 'lodash'

export function deviseCal(from, to) {
  let output = from
  if (parseInt(to)) {
    output = output * parseInt(to)
  }
  return parseFloat(output).toFixed(2)
}
export function currentDate() {
  const dateNow = new Date() // Creating a new date object with the current date and time
  const year = dateNow.getFullYear() // Getting current year from the created Date object
  const monthWithOffset = dateNow.getUTCMonth() + 1 // January is 0 by default in JS. Offsetting +1 to fix date for calendar.
  const month = // Setting current Month number from current Date object
    monthWithOffset.toString().length < 2 // Checking if month is < 10 and pre-prending 0 to adjust for date input.
      ? `0${monthWithOffset}`
      : monthWithOffset
  const date =
    dateNow.getUTCDate().toString().length < 2 // Checking if date is < 10 and pre-prending 0 if not to adjust for date input.
      ? `0${dateNow.getUTCDate()}`
      : dateNow.getUTCDate()
  const materialDateInput = `${year}-${month}-${date}`
  return materialDateInput
}

export function convertToMuiDate(date) {
  const tmpDate = date.split('-')
  const materialDateInput = `${tmpDate[2]}-${tmpDate[1]}-${tmpDate[0]}`
  return materialDateInput
}
export function convertToUserDateFormate(user, date) {
  let date_formate = user?.user_parameter?.format_de_date
  let materialDate = date
  if (date) {
    const tmpDate = date.split('-')
    if (date_formate === 'MM.dd.yyyy') materialDate = `${tmpDate[1]}-${tmpDate[0]}-${tmpDate[2]}`
    if (date_formate === 'yyyy.MM.dd') materialDate = `${tmpDate[2]}-${tmpDate[1]}-${tmpDate[0]}`
    if (date_formate === 'yyyy.dd.MM') materialDate = `${tmpDate[2]}-${tmpDate[0]}-${tmpDate[1]}`
  }

  return materialDate
}

// Convert text with \n to React elements with line breaks
export function formatTextWithLineBreaks(text) {
  if (!text) return text
  
  // Split by \n and map to React elements with <br /> tags
  const lines = text.split('\\n')
  
  return lines.map((line, index) => (
    <span key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </span>
  ))
}

export function sanatizeServerError(response) {
  if (response.error) {
    const newResponse = {}
    Object.keys(response).forEach((key) => {
      if (key !== 'error') {
        const firstResponse = _.first(response[key])
        if (firstResponse) {
          newResponse[key] = firstResponse.message
        }
      }
    })
    return newResponse
  }
  return response
}
